<template>
  <div>
    <base-button block type="primary" class="mt-0" @click="modal = true">
      {{ $t('passwordChange.btnLabel') }}
    </base-button>

    <modal id="systemAccountPasswordChangeModal"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="closeModal()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('passwordChange.view.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-2">
          <small>{{ $t('passwordChange.view.helpText') }}</small>
        </div>

        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" v-on:submit.prevent="validate()">
          <div class="row">
            <div class="col">
              <base-input
                name="password"
                type="password"
                v-validate="'required|min:9'"
                :error="getError('password')"
                v-model="formDetails.password"
                :placeholder="$t('passwordReset.passwordPlaceholder')"
                addon-left-icon="tim-icons icon-lock-circle"
                ref="password"
              >
              </base-input>
              <base-input
                name="confirmedPassword"
                type="password"
                v-validate="'required|confirmed:password'"
                :error="getError('confirmedPassword')"
                v-model="formDetails.confirmedPassword"
                :placeholder="$t('passwordReset.confirmedPasswordPlaceholder')"
                addon-left-icon="tim-icons icon-single-copy-04"
              >
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              :loading="updating"
              type="primary"
              class="my-4"
              @click="validate()"
            >{{ $t('passwordChange.form.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {mapActions, mapState} from "vuex";

export default {
  name: 'PasswordChangeBtn',
  components: {
    [Option.name]: Option,
    BaseAlert,
    Modal,
  },
  props: {
    systemAccountId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      error: state => state.psw.error,
      updating: state => state.psw.updating,
    }),

    getActionErrorDetails() {
      return this.error
    }
  },
  methods: {
    ...mapActions(['PasswordChange']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.changePassword()
        }
      });
    },
    changePassword: function () {
      this.alert = false;

      const payload = {
        data: {
          password: this.formDetails.password,
        },
        systemAccountId: this.systemAccountId,
      }

      this.PasswordChange(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('passwordChange.successNotification'),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.closeModal();
        }
      });
    },
    resetForm: function () {
      this.formDetails.password = ""
      this.formDetails.confirmedPassword = ""
      this.$validator.reset()
    },
    closeModal: function () {
      this.modal = false;
      this.resetForm();
    }
  },
  data() {
    return {
      modal: false,
      alert: false,
      formDetails: {
        password: '',
        confirmedPassword: ''
      },
    }
  }
}
</script>
